<div
  class="tag"
  [ngClass]="{
    'green': value,
    'purple': !value,
  }"
>
  <span>{{ value ? "Yes" : "No" }}</span>
</div>
